/* 菜单项上的 demoOnly 表示灰度演示入口：只有后端显示配置放行的用户才展示，
   与路由 meta.demoOnly 同名同义，由 src/service/api/app.js 统一过滤。
   判据取自 /user/menu-display-config/check，
   判定与边界（含「这不是访问控制」的说明）见 @/utils/menuDisplayConfig */

const mainMenus = [
  {
    label: '策略规划智能体',
    icon: 'images/menuIcon/home.png',
    activeIcon: 'images/menuIcon/homeActive.png',
    activePath: '/agentCluster',
    activePaths: ['/agentCluster'],
    path: '/agentCluster/input/MARKETING_EVENT_CLUSTER/agent_cluster/marketing_event_cluster',
    showPosition: 'menu',
    permissionsKey: 'agentCluster',
    children: []
  },
  {
    label: '策略规划智能体',
    icon: 'images/menuIcon/home.png',
    activeIcon: 'images/menuIcon/homeActive.png',
    activePath: '/strategyPlanning',
    activePaths: ['/strategyPlanning'],
    path: '/strategyPlanning',
    showPosition: 'menu',
    permissionsKey: 'strategyPlanning',
    demoOnly: true,
    /* 与上方同名的智能体集群菜单互斥：本项对名单内用户可见时，agentCluster 菜单隐藏，
       侧栏始终只出现一个「策略规划智能体」 */
    replaceMenuKeys: ['agentCluster'],
    children: []
  },
  {
    label: '创意制作智能体',
    icon: 'images/menuIcon/writingAgent.png',
    activeIcon: 'images/menuIcon/writingAgentActive.png',
    activePath: '/offerAgentPlaza',
    activePaths: [
      '/offerAgentPlaza',
      '/offerAgentChat',
      '/writingAgent',
      '/videoAgent',
      '/designAgent'
    ],
    path: '/offerAgentPlaza',
    showPosition: 'menu',
    permissionsKey: 'offerAgentPlaza',
    children: []
  },
  {
    label: '岗位助理智能体',
    icon: 'images/menuIcon/icon8.png',
    activeIcon: 'images/menuIcon/icon8A.png',
    activePath: '/lobsterPlaza',
    activePaths: ['/lobsterPlaza'],
    path: '/lobsterPlaza',
    showPosition: 'menu',
    permissionsKey: 'lobsterPlaza',
    children: []
  },

  {
    label: '营销管理指挥室',
    icon: 'images/menuIcon/home.png',
    activeIcon: 'images/menuIcon/homeActive.png',
    activePath: '/cmoDashboard',
    activePaths: ['/cmoDashboard'],
    path: '/cmoDashboard',
    showPosition: 'menu',
    permissionsKey: 'cmoDashboard',
    demoOnly: true,
    children: []
  },
  {
    label: '营销智慧资产库',
    icon: 'images/menuIcon/brandVoice.png',
    activeIcon: 'images/menuIcon/brandVoiceActive.png',
    activePath: '/brandStandard',
    activePaths: ['/brandStandard', '/brandVoice', '/knowledge', '/enterpriseModel'],
    path: '/brandStandard',
    showPosition: 'menu',
    permissionsKey: 'brandStandard',
    children: []
  }
]

const accountMenus = [
  {
    label: '个人中心',
    icon: 'images/menuIcon/brain.png',
    activeIcon: 'images/menuIcon/brainActive.png',
    activePath: '/user',
    path: '/user/userSetting',
    showPosition: 'dropdown',
    permissionsKey: 'user',
    children: [
      {
        label: '基本设置',
        type: 'root',
        activePath: '/user/userSetting',
        routeName: 'UserSetting',
        permissionsKey: 'userSetting'
      },
      {
        label: '安全设置',
        type: 'root',
        activePath: '/user/userSafe',
        routeName: 'UserSafe',
        permissionsKey: 'userSafe'
      },
      {
        label: '我的套餐',
        type: 'root',
        activePath: '/user/combo',
        routeName: 'combo',
        permissionsKey: 'combo'
      },
      {
        label: '消耗日志',
        type: 'root',
        activePath: '/user/consumption',
        routeName: 'consumption',
        permissionsKey: 'consumption'
      }
    ]
  },
  {
    label: '团队中心',
    icon: 'images/menuIcon/brain.png',
    activeIcon: 'images/menuIcon/brainActive.png',
    activePath: '/team',
    path: '/team/teamPackage',
    showPosition: 'dropdown',
    permissionsKey: 'team',
    children: []
  }
]
const userMenus = [
  {
    label: '我管理的Campaign',
    icon: 'images/menuIcon/home.png',
    activeIcon: 'images/menuIcon/homeActive.png',
    activePath: '/myCampaign',
    activePaths: ['/myCampaign'],
    path: '/myCampaign',
    showPosition: 'userMenu',
    permissionsKey: 'myCampaign',
    children: []
  },
  {
    label: '我制作的物料',
    icon: 'images/menuIcon/writingAgent.png',
    activeIcon: 'images/menuIcon/writingAgentActive.png',
    activePath: '/myOffer',
    activePaths: ['/myOffer'],
    path: '/myOffer',
    showPosition: 'userMenu',
    permissionsKey: 'myOffer',
    children: []
  },
  {
    label: '我的素材资产',
    icon: 'images/menuIcon/icon8.png',
    activeIcon: 'images/menuIcon/icon8A.png',
    activePath: '/myResbrandStandardource',
    activePaths: ['/myResource'],
    path: '/myResource',
    showPosition: 'userMenu',
    permissionsKey: 'myResource',
    children: []
  }
]
export const menuList = [...mainMenus, ...accountMenus, ...userMenus]
export const newMenuList = [...mainMenus, ...accountMenus, ...userMenus]
